module.exports = __webpack_public_path__ + "static/media/menu.d7d01f12.svg";